import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { IonPopover, Platform } from '@ionic/angular';
import { CommonAlertService } from 'src/app/services/alert/alert.service';

import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SiteLocationService } from 'src/app/services/site-location/site-location.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';

interface IExternalLink {
  code: string;
  description: string | null;
  extraTags: string | null;
  iconName: string | null;
  icon_id: string | null;
  id: number;
  isActive: number;
  isExternalUrl: boolean | null;
  isHamburgerMenu: number;
  isLobbyNavBar: number;
  keywords: null
  label: string;
  lobbyNavBarPosition: number
  promotion_id: string | null;
  title: string;
  url: string;
}

@Component({
  selector: 'app-playin-state-selector',
  templateUrl: './playin-state-selector.component.html',
  styleUrls: ['./playin-state-selector.component.scss'],
})
export class PlayinStateSelectorComponent implements OnInit {
  @Input() isAuthenticated:boolean = false;
  @ViewChild(IonPopover, { static: false }) popOver!:IonPopover;
  
  statesMap:{[key:string]:string};
  states:{[key:string]:string}[];
  selectedState:string;
  jurisdictionExternalLinks:IExternalLink[];
  popOverHostElementId:string;
  isIOS: boolean = false;
  private isPopupOverOpen:boolean;

  constructor(
    public config: ConfigService,
    public eventsService: EventsService,
    public platform: Platform,
    public siteLocationService: SiteLocationService,
    public uniqueIDService:UniqueIDService,
    public commonAlertService: CommonAlertService
    ) {
    this.popOverHostElementId = this.uniqueIDService.uuidv4();
    //const statesMap = siteLocationService.statesMap;
    const statesMap = {
      'PA': 'Pennsylvania',
      'NJ': 'New Jersey',
    }
    this.statesMap = statesMap;
    const stateKeys = Object.keys(statesMap);
    this.states = stateKeys.map( key => ({code: key, value: statesMap[key]}));
    
  }

  ngOnInit() {
    this.isIOS = this.platform.is("ios");
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        this.getJurisdictionExternalLinks();
      });
    });

    this.config.isLoaded().then(() => {
      this.getJurisdictionExternalLinks();
    });
  }

  public getJurisdictionExternalLinks() {
    const externalLinks = this.config?.getExternalLinks()?.payload;
    this.jurisdictionExternalLinks = externalLinks?.filter( link => 
        link.isHamburgerMenu === 1 && link.code === 'jurisdiction' && !!link.label);
    if(this.jurisdictionExternalLinks?.length > 0) {
      const stateKeys = Object.keys(this.statesMap);
      this.selectedState = stateKeys.filter( key => key != this.jurisdictionExternalLinks[0]?.label)[0];
     }
  }

  changeState(newState:string) {
    this.selectedState = newState;
    const url = this.jurisdictionExternalLinks[0].url;
    this.siteLocationService.changeState(url, this.selectedState);
  }

  onChangePlayinState(value:string) {
    const jurisdictionExternalLinks = this.jurisdictionExternalLinks;
    if(value && value != this.selectedState && jurisdictionExternalLinks?.length > 0) {
      
      setTimeout( ()=> this.popOver.dismiss(), 500);
      if(this.isAuthenticated) {
        this.presentAlert(value);
      }
      else {
        this.selectedState = value;
        this.changeState(value);
      }
    }
  }

  async presentAlert(state:string) {
    await this.commonAlertService.changeJurisdiction(() => this.changeState(state));
  }

  onPopoverDidPresentHandle($event:Event) {
    this.isPopupOverOpen = true;
  }
  
  onPopoverDidDismissHandle($event) {
    this.isPopupOverOpen = false;
  }

  handleSizeRotate() {
    if(this.isPopupOverOpen) {
      this.popOver.dismiss();
    }
  }
}
